import React, { useState, useEffect } from "react";
import StorageTankForm from "./StorageTankForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddStorageForm from "./AddStorageTank";
import { store } from "../../../../redux-store/store";
import { formatAmount } from "../../../utils/formatPrice";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "25%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "location", label: "Location" },
  { id: "tankShortName", label: "Tank Short Name" },
  { id: "storageTankDescription", label: "Storage Tank Description" },
  { id: "maxVolume", label: "Max Volume" },
  { id: "status", label: "Active Status" },
  { id: "createdAt", label: "Date Created" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Locations({ storageTanks, locations, AddStorageTank }) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(storageTanks, headCells, filterFn);
  useEffect(() => {
    store.dispatch({ type: "LOAD_STORAGE_TANKS" });
    store.dispatch({ type: "LOAD_LOCATIONS" });
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (StorageTank, resetForm) => {
    if (StorageTank.id === 0) AddStorageTank(StorageTank);
    else var data = { ...StorageTank };
    store.dispatch({ type: "UPDATE_STORAGE_TANK", payload: data });
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  // Old Redux Call  - ADD_LOCATION

  const addStorageTank = (storageTank, resetForm) => {
    store.dispatch({ type: "ADD_STORAGE_TANK", payload: storageTank });
    resetForm();
    setRecordForEdit(null);
    setAddOpenPopup(false);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };
  const onDelete = (id) => {
    store.dispatch({ type: "DELETE_STORAGE_TANK", payload: id });
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  return (
    <>
      <div
        className="container"
        style={{ paddingTop: "40px", marginTop: "-5rem" }}
      >
        <div>
          <Column flexGrow={1}>
            <ToastContainer />
            <div className="mt-4 pr-3">
              <Controls.Input
                placeholder="Search Storage Tanks by Tank Name"
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
              />
            </div>
            <Paper className={classes.pageContent}>
              <h4>
                <strong> Storage Tanks </strong>
              </h4>
              <Toolbar>
                <Controls.Button
                  text="Add New"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  className={classes.newButton}
                  onClick={() => {
                    setAddOpenPopup(true);
                    setRecordForEdit(null);
                  }}
                />
              </Toolbar>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.locationInfo.locationName}</TableCell>
                      <TableCell>{item.tankShortName}</TableCell>
                      <TableCell>{item.storageTankDescription}</TableCell>
                      <TableCell>{formatAmount(item.maxVolume)}</TableCell>
                      <TableCell> {item.activeStatus?.toString()}</TableCell>
                      <TableCell>{item.createdAt}</TableCell>
                      <TableCell>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            openInPopup(item);
                          }}
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </Controls.ActionButton>
                        <Controls.ActionButton
                          color="secondary"
                          onClick={() => {
                            setConfirmDialog({
                              isOpen: true,
                              title: "Are you sure to delete this record?",
                              subTitle: "You can't undo this operation",
                              onConfirm: () => {
                                onDelete(item.id);
                              },
                            });
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>
            <Popup
              title="Edit Storage Tank Form"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <StorageTankForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                locations={store.getState().locationReducer.locations}
              />
            </Popup>

            <Popup
              title="Add Storage Tank Form"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddStorageForm
                recordForEdit={recordForEdit}
                addStorageTank={addStorageTank}
                locations={store.getState().locationReducer.locations}
              />
            </Popup>
            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    storageTanks: state.storageTanksReducer.storageTanks,
    locations: state.locationReducer.locations,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateStorageTank(payload) {
    dispatch({ type: "UPDATE_STORAGE_TANK", payload });
  },

  LoadStorageTanks(payload) {
    dispatch({ type: "LOAD_STORAGE_TANKS", payload });
  },
  LoadLocations(payload) {
    dispatch({ type: "LOAD_LOCATIONS", payload });
  },
  AddStorageTank(payload) {
    dispatch({ type: "ADD_STORAGE_TANK", payload });
  },

  DeleteStorageTank(payload) {
    dispatch({ type: "DELETE_STORAGE_TANK", payload });
  },
});

// UpdateLocation

export default connect(mapStateToProps, mapDispatchToProps)(Locations);
